// extracted by mini-css-extract-plugin
module.exports = {"forumPosts":"styles-module__forumPosts___Ov_de"};